<template>
    <transition name="dialog-fade">
        <div v-show="visible">
            <div class="v-modal"></div>
            <div class="dialog-wrapper" @click.self="handleWrapperClick">
                <div
                    class="popbox plugin-dialog"
                    :class="[sizeClass, customClass]"
                    ref="dialog"
                    :style="style">
                    <div class="el-dialog__header">
                        <div class="small-icon3 popbox-btn-close" v-if="showClose" @click="handleClose"></div>
                        <div class="popbox-title">
                            <slot name="title">
                                <div class="text">{{title}}</div>
                            </slot>
                        </div>
                    </div>
                    <div class="popbox-container" :class="[customContainerClass]" v-if="rendered" @scroll="scrollEvent($event)">
                        <slot></slot>
                    </div>

                    <div style="margin-top: 20px;" class="popbox-footer plugin-dialog-footer" v-if="$slots.footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
// import Popup from 'element-ui/src/utils/popup';
// import emitter from 'element-ui/src/mixins/emitter';

export default {
    // mixins: [Popup, emitter],
    data: function () {
        return {
            opened: false,
            bodyOverflow: null,
            bodyPaddingRight: null,
            rendered: true
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },

        modal: {
            type: Boolean,
            default: true
        },

        modalAppendToBody: {
            type: Boolean,
            default: true
        },

        lockScroll: {
            type: Boolean,
            default: true
        },

        closeOnClickModal: {
            type: Boolean,
            default: true
        },

        closeOnPressEscape: {
            type: Boolean,
            default: true
        },

        showClose: {
            type: Boolean,
            default: true
        },

        size: {
            type: String,
            default: 'tiny'
        },

        customClass: {
            type: String,
            default: ''
        },

        customContainerClass: {
            type: String,
            default: ''
        },

        top: {
            type: String,
            default: '15%'
        },
        beforeClose: Function,
        containerScrollEvent: Function
    },

    watch: {
        visible: function (val) {
            this.$emit('update:visible', val)

            if (val) {
                this.$emit('open')
                // this.$el.addEventListener('scroll', this.updatePopper)
                this.$nextTick(function () {
                    this.$refs.dialog.scrollTop = 0
                })
                if (this.lockScroll) {
                    if (!this.bodyOverflow) {
                        this.bodyPaddingRight = document.body.style.paddingRight
                        this.bodyOverflow = document.body.style.overflow
                    }
                    document.body.style.overflow = 'hidden'
                }
            } else {
                if (this.lockScroll) {
                    var self = this
                    setTimeout(function () {
                        if (self.modal && self.bodyOverflow !== 'hidden') {
                            document.body.style.overflow = self.bodyOverflow
                            document.body.style.paddingRight = self.bodyPaddingRight
                        }
                        self.bodyOverflow = null
                        self.bodyPaddingRight = null
                    }, 200)
                }
                // this.$el.removeEventListener('scroll', this.updatePopper)
                this.$emit('close')
            }
        }
    },

    computed: {
        sizeClass: function () {
            return 'el-dialog--' + this.size
        },
        style: function () {
            return this.size === 'full' ? {} : { 'top': this.top }
        }
    },

    methods: {
        handleWrapperClick: function () {
            if (!this.closeOnClickModal) return
            this.handleClose()
        },
        handleClose: function () {
            if (typeof this.beforeClose === 'function') {
                this.beforeClose(this.hide)
            } else {
                this.hide()
            }
        },
        hide: function (cancel) {
            if (cancel !== false) {
                this.$emit('update:visible', false)
                this.$emit('visible-change', false)
            }
        },
        updatePopper: function () {
            // this.broadcast('ElSelectDropdown', 'updatePopper')
            // this.broadcast('ElDropdownMenu', 'updatePopper')
        },
        open: function (options) {
            if (!this.rendered) {
                this.rendered = true
                this.$emit('visible-change', true)
            }

            // var props = merge({}, this.$props || this, options)

            // if (this._closeTimer) {
            //     clearTimeout(this._closeTimer)
            //     this._closeTimer = null
            // }
            // clearTimeout(this._openTimer)

            // this.doOpen(props)
            // const openDelay = Number(props.openDelay)
            // if (openDelay > 0) {
            //     this._openTimer = setTimeout(() => {
            //         this._openTimer = null
            //         this.doOpen(props)
            //     }, openDelay)
            // } else {
            //     this.doOpen(props)
            // }
        },
        scrollEvent: function (event) {
            if (typeof this.containerScrollEvent === 'function') {
                this.containerScrollEvent(event)
            }
        }
    },

    mounted: function () {
        if (this.visible) {
            this.rendered = true
            this.open()
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../scss/common/dialog.scss';
</style>



// WEBPACK FOOTER //
// src/components/lib/dialog.vue